import React from "react";
import { Button } from "react-bootstrap";
import { Link } from "react-router-dom";
import luniwave_icon from "../img/Luniwave_icon.png";
import Translation from "./Translation";

const NavbarUser = ({ viewID }) => {
    return (
        <div className={`navbar-hotel-2 ${viewID === "mySimulator" ? "navbar-simulator" : ""}`}>
            <div className="logo-section-navbarhotel">
                <img src={luniwave_icon} alt="Logo" className="navbar-logo-2" />
                <span className="hotel-name">
                    {viewID === "mySimulator" ? "Simulateur LuniShower Accor" : <Translation tag={"Hotel_Access"} />}
                </span>
            </div>
            {viewID !== "mySimulator" && (
                <Link to="/user/hotels" className="linkHotels">
                <span className="more-arrow-3">→</span>
                </Link>
            )}
        </div>
    );
};

export default NavbarUser;
